import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ThemeService } from './core/services/theme.service';
import { TranslationService } from './core/services/translation.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideNgxMask } from 'ngx-mask';
import { OtelErrorHandlerService } from '@core/services/otel-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // Enable zoneless change detection (no Zone.js required)
    provideZonelessChangeDetection(),
    provideAnimations(),
    // Auth interceptor must come before error interceptor to handle token refresh
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    // Note: Service worker is handled manually in GeneralComponent
    // We use a custom service worker (staqable-service-worker.js) not Angular's ngsw-worker.js
    ThemeService,
    TranslationService,
    provideNgxMask(),
    { provide: ErrorHandler, useClass: OtelErrorHandlerService },
  ],
};
